import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { Tree } from 'primereact/tree';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { IndorImages, getIndorImageSrc } from '../../features';
import { useAppSelector } from '../../stateManagement/hooks/redux';
import { changeFavouritesList, deleteFavouriteList, deleteRoadFromList, deleteTypeFromList, deleteValueFromList, setExpandedFavouriteKeys } from '../../stateManagement/reducers/FavouritesSlice';
import { store } from '../../stateManagement/store';
import { getItemWebStorage, setItemWebStorage } from '../../features/webStorageSaver';
import ContentHeader from '../../widgets/contentHeader/ContentHeader';
const trashCanSrc = require('../../assets/images/fontAwesomeIcons/trash-can-solid.svg').default

// модель объекта в дереве данных
interface TreeNode {
    key: string;
    label: string;
    data?: string;
    icon?: JSX.Element | string;
    children?: any;
    link?: string;
    objectType?: string;
    listName?: string;
    roadDirectionName?: string;
    nodeType?: string;
    id?: string;
}

// Страница с отображением дерева закладок
export function NewFavouritesPage() {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    // узлы дереве данных
    const [nodes, setNodes] = useState<TreeNode[]>([]);
    // развернутые узлы
    const [expandedKeys, setExpandedKeys] = useState({});
    // получение типов объектов из localStorage
    const objectTypes = getItemWebStorage("objectTypes")
    // флаг удаления закладки
    const changeFavouritesMark = useAppSelector(state => state.favourites.favouriteDeleted)

    useEffect(() => {
        let favourites = store.getState().favourites.lists
        if (getItemWebStorage("favourites")) {
            favourites = getItemWebStorage("favourites")
            dispatch(changeFavouritesList(favourites))
        }
        setNodes(configureNodes(createTreeNodes(favourites)))
        setExpandedKeys(store.getState().favourites.expandedKeys)
    }, [changeFavouritesMark])

    // функция для распределения узлов дерева данных
    function configureNodes(arr: any) {
        return arr.reduce(
            (acc: any, item: any) => {
                const newItem = item;
                if (item.children) {
                    newItem.children = configureNodes(item.children);
                }
                if ((newItem.children + '').length > 0) {
                    acc.push(newItem);
                }
                return acc;
            }, []);
    }

    // функция раскрытия узла
    function toggleExpand(value: any) {
        setExpandedKeys(value)
        dispatch(setExpandedFavouriteKeys(value))
    }

    // функция для раскрытия всех узлов
    function expandAll() {
        let _expandedKeys = {};
        for (let node of nodes) {
            expandNode(node, _expandedKeys);
        }
        setExpandedKeys(_expandedKeys);
        dispatch(setExpandedFavouriteKeys(_expandedKeys))
    }

    // функция для сворачивания всех узлов
    function collapseAll() {
        setExpandedKeys({});
        dispatch(setExpandedFavouriteKeys({}))
    }

    // функция для создания узлов дерева данных из предоставленного массива
    function createTreeNodes(data: any[], parentKey: string = '') {
        let count = -1
        return data.map((item) => {
            count++
            let icon: any
            let children: any
            let label: any
            let link: any
            let listName, roadDirectionName, id
            let nodeType: any
            const { imageIndex, caption, captionSingular } = objectTypes.find((objectType: any) => objectType.name === item?.name) ?? {}
            const key = parentKey ? `${parentKey}-${count}` : `${count}`;
            // распределения данных по уровням: список - дорога - тип - объект
            if (item.roadDirections) {
                label = item.name
                children = item.roadDirections
                icon = "pi pi-list"
                nodeType = 'list'
            }
            if (item?.types) {
                listName = item.listName
                label = item.name
                icon = "icon-1625"
                children = item?.types
                nodeType = 'road'
            }
            if (item.items) {
                listName = item.listName
                roadDirectionName = item.roadDirectionName
                label = caption
                icon = `icon-${imageIndex.toString().padStart(4, '0')}`
                children = item.items
                nodeType = 'type'
            }
            if (!item.roadDirections && !item?.types && !item.items) {
                const position = item.position
                const ending = item.ending
                const placement = item.placement
                listName = item.listName
                roadDirectionName = item.roadDirectionName
                id = item.id
                label = captionSingular + ' - #' + item.id + `${position ? ` (${position ? position + ' км' : ''}${ending ? ' — ' + ending + ' км' : ''}${(placement && placement !== 'не указано')
                    ? ' — ' + placement : ''})` : ''} `
                icon = item.name === 'RoadSigns' ? item.addParams.signImage : `icon-${imageIndex.toString().padStart(4, '0')}`
                link = `${item.name}/${item.id}`
                nodeType = 'item'
            }
            const treeNode: TreeNode = {
                key: key,
                label: label,
                data: label,
                icon: icon,
                children: (children) ? createTreeNodes(children, key) : null,
                link: link,
                objectType: item.name,
                listName: listName,
                roadDirectionName: roadDirectionName,
                nodeType: nodeType,
                id: id
            };
            return treeNode;
        }).filter(item => item !== null);
    }

    // функция раскрытия узла (составляющая функции раскрытия всех узлов)
    function expandNode(node: any, _expandedKeys: any) {
        if (node.children && node.children.length) {
            _expandedKeys[node.key] = true;
            for (let child of node.children) {
                expandNode(child, _expandedKeys);
            }
        }
    }

    // обработчик нажатия на закладку (переход на страницу объекта)
    function onSelect(event: any) {
        if (event.node.link) {
            navigate(`/app/table/${event.node.link}`)
        }
    }

    // функция удаления закладки из списка и обновления соответствующих состояний
    function deleteFavouriteFromList(roadDirectionName: string, listName: string, objectType: string, id: string, event: any, nodeType: any, node: any) {
        event.stopPropagation()
        const favouriteDeleteMark = store.getState().favourites.favouriteDeleted
        if (nodeType === 'item') {
            dispatch(deleteValueFromList({ listName: listName, roadDirectionName: roadDirectionName, type: objectType, id: id, favouriteDeleted: !favouriteDeleteMark }))
        }
        if (nodeType === 'type') {
            dispatch(deleteTypeFromList({ listName: listName, roadDirectionName: roadDirectionName, type: objectType, favouriteDeleted: !favouriteDeleteMark }))
        }
        if (nodeType === 'road') {
            dispatch(deleteRoadFromList({ listName: listName, roadDirectionName: node.label, favouriteDeleted: !favouriteDeleteMark }))
        }
        if (nodeType === 'list') {
            dispatch(deleteFavouriteList({ name: node.label, favouriteDeleted: !favouriteDeleteMark }))
        }
        const favourites = store.getState().favourites.lists
        setItemWebStorage('favourites', favourites)
    }

    // шаблон узла дерева данных
    function getNodeTemplate(node: any, options: any) {
        let label = node.label
        let id = 'type=' + node.nodeType + ' listName=' + node.listName + ' roadName=' + node.roadDirectionName + ' objectType=' + node.objectType + ' id=' + node.id
        function onMouseOver() {
            const button = document.getElementById(id);
            if (button) {
                button.classList.remove('d-none');
                button.classList.add('d-flex');
            }
        }
        function onMouseOut() {
            const button = document.getElementById(id);
            if (button) {
                button.classList.remove('d-flex');
                button.classList.add('d-none');
            }
        }
        function toggle(event: any) {
            toggleExpand({ ...options.props.expandedKeys, [options.props.node.key]: (!options.expanded ? true : undefined) })
        }
        let groupNode = false
        if (node.url) {
            label = <a href={node.url} className="text-700 hover:text-primary" target="_blank" rel="noopener noreferrer">{node.label}</a>;
        }
        if (!node.key.includes('-')) {
            groupNode = true
        }

        return (
            <>
                {(node.objectType === 'RoadSigns' && !node.children) ?
                    <div className="d-flex align-items-center node-div" onMouseOver={onMouseOver} onMouseOut={onMouseOut}>
                        <img className="me-2" src={node?.icon} style={{ width: '32px', height: '32px' }} />
                        <span className={options.className}>{label}</span>
                        <Button
                            onClick={(event) => deleteFavouriteFromList(node.roadDirectionName, node.listName, node.objectType, node.id, event, node.nodeType, node)}
                            className="delete-but text-center d-none" id={id}
                            severity="danger"><img src={trashCanSrc} height={16} width={16} />
                        </Button>
                    </div>
                    :
                    <>
                        {groupNode
                            ?
                            <div className="d-flex align-items-center node-div" onClick={(e) => toggle(e)} onMouseOver={onMouseOver} onMouseOut={onMouseOut}>
                                <span className={options.className}>{label}</span>
                                <Button
                                    onClick={(event) => deleteFavouriteFromList(node.roadDirectionName, node.listName, node.objectType, node.id, event, node.nodeType, node)}
                                    className="delete-but text-center d-none" id={id}
                                    severity="danger"><img src={trashCanSrc} height={16} width={16} />
                                </Button>
                            </div>
                            :
                            <div className="d-flex align-items-center node-div" onClick={(e) => toggle(e)} onMouseOver={onMouseOver} onMouseOut={onMouseOut}>
                                <span className={options.className}>{label}</span>
                                <Button
                                    onClick={(event) => deleteFavouriteFromList(node.roadDirectionName, node.listName, node.objectType, node.id, event, node.nodeType, node)}
                                    className="delete-but text-center d-none" id={id}
                                    severity="danger"><img src={trashCanSrc} height={16} width={16} />
                                </Button>
                            </div>
                        }
                    </>
                }
            </>
        );
    }

    return (
        <>
            <ContentHeader title="Списки закладок" />
            {(nodes.length > 0)
                ?
                <div className="new-favourites-list-div">
                    <div className="toggle-buttons-div flex flex-wrap gap-2 mb-4  mt-4">
                        <Button type="button" size="small" severity="info" className="me-3 toggle-button" icon="pi pi-plus" label="Раскрыть" onClick={expandAll} />
                        <Button type="button" size="small" severity="info" className="toggle-button" icon="pi pi-minus" label="Свернуть" onClick={collapseAll} />
                    </div>
                    <div className="new-favourites-div">
                        <Tree value={nodes} nodeTemplate={getNodeTemplate} selectionMode="single" onSelect={onSelect} expandedKeys={expandedKeys} onToggle={(e) => toggleExpand(e.value)} className="w-full md:w-30rem" />
                    </div>
                </div>
                :
                <div className="new-favourites-empty-div">
                    <Card title="Нет закладок">
                        <p className="new-favourites-empty-card-text">
                            <span>Закладки отсутствуют. При просмотре объекта ГИС нажмите кнопку</span>
                            <img className="img-thumbnail empty-favourites-img" src={getIndorImageSrc(IndorImages.CommonFavourite)} />
                        </p>
                    </Card>
                </div>
            }
        </>
    );
}

